import {
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
  FetchArgs,
  BaseQueryFn,
  QueryReturnValue,
} from '@reduxjs/toolkit/query/react';
import { getCookie } from 'helpers/index';

// Same-origin: React is served by Django, so cookies (sessionid, csrftoken) are
// sent automatically. Full /api/v1.0/... paths are used in each endpoint.
const baseQueryInitial = fetchBaseQuery({
  baseUrl: '/',
  credentials: 'same-origin',
  prepareHeaders: (headers) => {
    const token = getCookie('csrftoken');
    if (token) headers.set('X-CSRFToken', token);
    headers.set('X-Requested-With', 'XMLHttpRequest');
    return headers;
  },
});

// Wrap the base query to redirect to Django login on 401.
export const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  Record<string, unknown>,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  const result: QueryReturnValue<
    unknown,
    FetchBaseQueryError,
    FetchBaseQueryMeta
  > = await baseQueryInitial(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    window.location.href = '/login/';
  }

  return result;
};
